import { render } from "./isiBerita.vue?vue&type=template&id=00241577"
import script from "./isiBerita.vue?vue&type=script&lang=js"
export * from "./isiBerita.vue?vue&type=script&lang=js"

import "./isiBerita.vue?vue&type=style&index=0&id=00241577&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__